// CommandQueue — the lockstep command intake (FIFO, fixed cap). game/ht.h:2271-2310,
// game/misc.cpp:18-110. Order = wire order = execution order: part of the determinism
// contract. SetEntry drops silently when full (canonical Enqueue-on-full semantics).

import {
  Message,
  cloneMessage,
  newMessage,
  encodeMessageMem,
  decodeMessageMem,
} from './message.ts';

// game/ht.h:2271
export const kcmsgCommandQueueMax = 300;

export class CommandQueue {
  private m_amsg: Message[] = [];
  private m_cmsgMax = kcmsgCommandQueueMax;

  // game/misc.cpp:30-37
  Init(cmsgMax = kcmsgCommandQueueMax): boolean {
    this.m_amsg.length = 0;
    this.m_cmsgMax = cmsgMax;
    return true;
  }

  // game/misc.cpp:89-96 — Enqueue(mid, smidReceiver): zeroed message
  EnqueueIds(mid: number, smidReceiver: number): void {
    this.SetEntry(newMessage(mid, 0, smidReceiver));
  }

  // game/misc.cpp:98-103 — Enqueue(Message*): clears tDelivery, copies
  Enqueue(pmsg: Message): void {
    pmsg.tDelivery = 0;
    this.SetEntry(cloneMessage(pmsg));
  }

  // game/misc.cpp:105-110 — copy into the array iff below cap, else silently drop
  private SetEntry(msg: Message): void {
    if (this.m_amsg.length < this.m_cmsgMax) this.m_amsg.push(msg);
  }

  // game/ht.h:2287-2297
  // game/misc.cpp:46-90 (knVerCommandQueueState 1) — raw 28-byte message images
  LoadState(pstm: import('./stream.ts').Stream): boolean {
    const nVer = pstm.ReadByte();
    if (nVer !== 1) return false;
    let cmsgs = pstm.ReadWord();
    while (cmsgs-- !== 0) {
      this.Enqueue(decodeMessageMem(pstm.Read(28).slice()));
    }
    return pstm.IsSuccess();
  }

  SaveState(pstm: import('./stream.ts').Stream): boolean {
    pstm.WriteByte(1);
    pstm.WriteWord(this.m_amsg.length);
    for (const m of this.m_amsg) {
      pstm.Write(encodeMessageMem(m));
      // dev hook: message-image span for the cross-validation masker (see mobileunit.ts)
      const ps = pstm as unknown as {
        tellWrite?: () => number;
        msgSpans?: { start: number; end: number }[];
      };
      if (ps.msgSpans !== undefined && ps.tellWrite !== undefined) {
        const end = ps.tellWrite();
        ps.msgSpans.push({ start: end - 28, end });
      }
    }
    return pstm.IsSuccess();
  }

  Clear(): void {
    this.m_amsg.length = 0;
  }
  GetFirst(): Message[] {
    return this.m_amsg;
  }
  GetCount(): number {
    return this.m_amsg.length;
  }
}
